import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule,HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './middleware/auth-interceptor'
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';


// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { PermissionsComponent } from './user_defined/components/permissions/permissions.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

//Angular powered Bootstrap
import { ScrollEventModule } from 'ngx-scroll-event';

//Angular Material
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';

//Angular Notifier
import { ToastrModule } from 'ngx-toastr';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CreateRolesComponent } from './user_defined/components/create-roles/create-roles.component';
import { RolesComponent } from './user_defined/components/roles/roles.component';
import { EditRolesComponent } from './user_defined/components/edit-roles/edit-roles.component';
import { PermissionsListComponent } from './user_defined/shared/permissions-list/permissions-list.component';
import { UsersProfileComponent } from './user_defined/components/users-profile/users-profile.component';
import { UsersHomeComponent } from './user_defined/components/users-home/users-home.component';
import { UsersListComponent } from './user_defined/shared/users-list/users-list.component';
import { LoginComponent } from './user_defined/components/login/login.component';
import { NgxLoadingModule } from 'ngx-loading';
import { RestrictionComponent } from './user_defined/shared/restriction/restriction.component';
import { MessagesComposeComponent } from './user_defined/shared/messages-compose/messages-compose.component';
import { SearchContactsComponent } from './user_defined/shared/search-contacts/search-contacts.component';
import { MessagesComponent } from './user_defined/components/messages/messages.component';
import { MessagesNavigationComponent } from './user_defined/shared/messages-navigation/messages-navigation.component';
import { CountryCodesComponent } from './user_defined/shared/country-codes/country-codes.component';
import { ContactsNavigationComponent } from './user_defined/shared/contacts-navigation/contacts-navigation.component';
import { ContactsComponent } from './user_defined/components/contacts/contacts.component';
import { ContactsHomeComponent } from './user_defined/shared/contacts-home/contacts-home.component';
import { ContactsProfileComponent } from './user_defined/shared/contacts-profile/contacts-profile.component';
import { ContactsGroupsComponent } from './user_defined/shared/contacts-groups/contacts-groups.component';
import { GroupsProfileComponent } from './user_defined/shared/groups-profile/groups-profile.component';
import { PermissionsProfileComponent } from './user_defined/shared/permissions-profile/permissions-profile.component';
import { HomeComponent } from './user_defined/components/home/home.component';
import { ListComponent } from './user_defined/shared/list/list.component';
import { MessagesAllComponent } from './user_defined/shared/messages-all/messages-all.component';
import { MessagesConversationComponent } from './user_defined/shared/messages-conversation/messages-conversation.component';
import { DateTimePickerComponent } from './user_defined/shared/date-time-picker/date-time-picker.component';
import { NgbModule, NgbPopoverModule, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { GroupsHomeComponent } from './user_defined/shared/groups-home/groups-home.component';


//Voice Modules
import { VoiceBatchComponent } from './modules/voice/voice-batch/voice-batch.component';
import { VoiceDetailComponent } from './modules/voice/voice-detail/voice-detail.component';
import { CallHistory } from './modules/voice/voice-detail/call-history';
import { CallHistoryComponent } from './modules/voice/call-history/call-history.component';
import { VoiceBatchTableComponent } from './modules/voice/voice-batch-table/voice-batch-table.component';
import { VoiceDetailTableComponent } from './modules/voice/voice-detail-table/voice-detail-table.component';
import { VoiceReportsComponent } from './modules/voice/voice-reports/voice-reports.component';
import { VoiceReportsTableComponent } from './modules/voice/voice-reports-table/voice-reports-table.component';

//Voice Module 3rd Party Plugins
import { NgbdModalBasic } from './modules/voice/modal-basic/modal-basic';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { BsDatepickerModule } from 'ngx-bootstrap';


//Email Module
//import { UnfullfilledComponent } from './modules/email/unfullfilled/unfullfilled.component';
//import { UnfullfilledFormComponent } from './modules/email/unfullfilled-form/unfullfilled-form.component'
//import { PccComponent } from './modules/email/pcc/pcc.component';
//import { DwkComponent } from './modules/email/dwk/dwk.component';
//import { PartnerSegmentComponent,PartnerSegmentViewDialog } from './modules/email/partner-segment/partner-segment.component'
//import { SegmentModal } from './modules/email/partner-segment/segment-modal'
import { Globals } from './service/shared/globals'


//Material
import { MatButtonModule,MatDatepickerModule } from '@angular/material';
import {AppMaterialModule} from './app-material.module';
//import { MergeTemplateComponent } from './modules/sms/merge-template/merge-template.component'
import { MergeTemplateComponent } from './modules/sms/merge-template/merge-template.component';
//import { EmailScheduleComponent } from './modules/email/email-schedule/email-schedule.component';
import { ReportsComponent } from './modules/joytogive/reports/reports.component';
import { MaintenanceComponent } from './modules/lazarus/maintenance/maintenance.component';
import { TablemakerComponent } from './modules/lazarus/tablemaker/tablemaker.component' ;


//Maintenance - Joy to give modal
import { SelectModal } from './modules/lazarus/tablemaker/selectmodal';
import { ItemComponent } from './modules/joytogive/item/item.component';
import { ItemMilestoneComponent } from './modules/joytogive/item-milestone/item-milestone.component';
import { WebsiteComponent } from './modules/joytogive/website/website.component';
import { UtmComponent } from './modules/joytogive/utm/utm.component';
import { CommentComponent } from './modules/joytogive/comment/comment.component'
import { FileModal } from './modules/joytogive/item/file-modal.component'




@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppMaterialModule,
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    FormsModule,
    HttpClientModule,
    NgbModule.forRoot(),
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(), // ToastrModule added,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatSelectModule,
    NgxLoadingModule.forRoot({}),
    NgMultiSelectDropDownModule.forRoot(),
    ScrollEventModule,
    PopoverModule.forRoot(),
    TimepickerModule.forRoot(),
    MatButtonModule,
    MatDatepickerModule,
    CKEditorModule,

  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    LoginComponent,
    PermissionsComponent,
    CreateRolesComponent,
    RolesComponent,
    EditRolesComponent,
    PermissionsListComponent,
    UsersProfileComponent,
    UsersHomeComponent,
    UsersListComponent,
    RestrictionComponent,
    MessagesComposeComponent,
    SearchContactsComponent,
    MessagesComponent,
    MessagesNavigationComponent,
    CountryCodesComponent,
    ContactsNavigationComponent,
    ContactsComponent,
    ContactsHomeComponent,
    ContactsProfileComponent,
    ContactsGroupsComponent,
    GroupsProfileComponent,
    PermissionsProfileComponent,
    HomeComponent,
    ListComponent,
    MessagesAllComponent,
    MessagesConversationComponent,
    DateTimePickerComponent,
    GroupsHomeComponent,
    VoiceBatchComponent,
    VoiceDetailComponent,
    CallHistoryComponent,
    NgbdModalBasic,
    CallHistory,
    VoiceBatchTableComponent,
    VoiceDetailTableComponent,
    VoiceReportsComponent,
    VoiceReportsTableComponent,
   // UnfullfilledComponent,
   // DwkComponent,
    // PartnerSegmentComponent,
    // PartnerSegmentViewDialog,
   // PccComponent,
   // UnfullfilledFormComponent,
    //SegmentModal,
    MergeTemplateComponent,
   // EmailScheduleComponent,
    ReportsComponent,
    MaintenanceComponent,
    TablemakerComponent,
    SelectModal,
    FileModal,
    ItemComponent,
    ItemMilestoneComponent,
    WebsiteComponent,
    UtmComponent,
    CommentComponent
  ],
  providers: [{
    provide: LocationStrategy,
    useClass: HashLocationStrategy,
  },
  Globals,
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  //entryComponents: [PartnerSegmentViewDialog],
  bootstrap: [AppComponent,CallHistory,SelectModal,FileModal]
})
export class AppModule { }
